
$(document).ready(function () {
    var interval;
    $(".close-baguier").data("url",document.referrer)
    InitBaguier();
})


function ResizeRing(size,modele) {
    let modeleSize = 0;
    if (modele == "CB") {
        modeleSize = 53.98;
    }
    else {
        modeleSize = 23.25;
    }
    let ringSize = $(".ring-size").data("size");
    let ringDiameter = ringSize / 3.14;
    let ringWidth = ringDiameter * size;
    ringWidth = ringWidth / modeleSize;
    $(".ring").width(ringWidth);
    $(".ring").height(ringWidth);
};

function InitBaguier() {
    //BAGUIER - MENU PIECE
    $(".baguier-coin-menu").on("click", function () {
        let content = $('.baguier__content');
        $.ajax(
            {
                cache: false,
                async: true,
                type: "GET",
                url: '/Product/ShowBaguierCoin/',
                success: function (data) {
                    content.html(data);
                },
                beforeSend: function () {
                    $('#preloader').show()
                },
                complete: function () {
                    $('#preloader').hide();
                }
            });
    })

    //BAGUIER - MENU CB
    $(".baguier-cb-menu").on("click", function () {
        let content = $('.baguier__content');
        $.ajax(
            {
                cache: false,
                async: true,
                type: "GET",
                url: '/Product/ShowBaguierBankcard/',
                success: function (data) {
                    content.html(data);
                },
                beforeSend: function () {
                    $('#preloader').show()
                },
                complete: function () {
                    $('#preloader').hide();
                }
            });
    })
    //BAGUIER - GESTION TAILLE 1EURO
    $(".coin-calibrate-buttons .plus").on("click", function () {
        let taille = $(".coin").width();
        $(".coin").width(taille + 1);
        $(".coin").height(taille + 1);
    })
    $(".coin-calibrate-buttons .minus").on("click", function () {
        let taille = $(".coin").width();
        $(".coin").width(taille - 1);
        $(".coin").height(taille - 1);
    })

    $(".coin-calibrate-buttons .minus").on("mousedown", function () {
        this.interval = setInterval(function () {
            let taille = $(".coin").width();
            $(".coin").width(taille - 1);
            $(".coin").height(taille - 1);
        }, 50);
    })
    $(".coin-calibrate-buttons .minus").on("mouseup", function () {
        clearInterval(this.interval);

    })
    $(".coin-calibrate-buttons .minus").on("mouseout", function () {
        clearInterval(this.interval);

    })

    $(".coin-calibrate-buttons .plus").on("mousedown", function () {
        this.interval = setInterval(function () {
            let taille = $(".coin").width();
            $(".coin").width(taille + 1);
            $(".coin").height(taille + 1);
        }, 25);
    })
    $(".coin-calibrate-buttons .plus").on("mouseup", function () {
        clearInterval(this.interval);

    })
    $(".coin-calibrate-buttons .plus").on("mouseout", function () {
        clearInterval(this.interval);

    })

    $(".coin-calibrate-buttons .minus").on("touchstart", function () {
        e.preventDefault();
        this.touchduration = 500;
        this.timer = 0;
        let taille = $(".coin").height();

        this.interval = setInterval(() => {
            this.timer += 20
            if (this.timer > this.touchduration) {
                $(".coin").height(taille--);
            }
        }, 20)
    })
    $(".coin-calibrate-buttons .minus").on("touchend", function () {
        clearInterval(this.interval);

    })
    $(".coin-calibrate-buttons .plus").on("touchstart", function () {
        e.preventDefault();
        this.touchduration = 500;
        this.timer = 0;
        let taille = $(".coin").height();

        this.interval = setInterval(() => {
            this.timer += 20
            if (this.timer > this.touchduration) {
                $(".coin").height(taille++);
            }
        }, 20)
    })
    $(".coin-calibrate-buttons .plus").on("touchend", function () {
        clearInterval(this.interval);

    })
    //BAGUIER - GESTION TAILLE CB

    $(".bankcard-calibrate-buttons .plus").on("click", function () {
        let taille = $(".bankcard").height();
        $(".bankcard").height(taille + 1);
    })

    $(".bankcard-calibrate-buttons .minus").on("click", function () {
        let taille = $(".bankcard").height();
        $(".bankcard").height(taille - 1);
    })

    $(".bankcard-calibrate-buttons .minus").on("mousedown", function () {
        this.interval = setInterval(function () {
            let taille = $(".bankcard").height();
            $(".bankcard").height(taille - 1);
        }, 25);
    })

    $(".bankcard-calibrate-buttons .minus").on("mouseup", function () {
        clearInterval(this.interval);
    })

    $(".bankcard-calibrate-buttons .minus").on("mouseout", function () {
        clearInterval(this.interval);
    })

    $(".bankcard-calibrate-buttons .plus").on("mousedown", function () {
        this.interval = setInterval(function () {
            let taille = $(".bankcard").height();
            $(".bankcard").height(taille + 1);
        }, 25);
    })

    $(".bankcard-calibrate-buttons .plus").on("mouseup", function () {
        clearInterval(this.interval);
    })

    $(".bankcard-calibrate-buttons .plus").on("mouseout", function () {
        clearInterval(this.interval);
    })

    $(".bankcard-calibrate-buttons .minus").on("touchstart", function () {
        e.preventDefault();
        this.touchduration = 500;
        this.timer = 0;
        let taille = $(".bankcard").height();

        this.interval = setInterval(() => {
            this.timer += 20
            if (this.timer > this.touchduration) {
                $(".bankcard").height(taille--);
            }
        }, 20)
    })
    $(".bankcard-calibrate-buttons .minus").on("touchend", function () {
        clearInterval(this.interval);
    })

    $(".bankcard-calibrate-buttons .plus").on("touchstart", function () {
        e.preventDefault();
        this.touchduration = 500;
        this.timer = 0;
        let taille = $(".bankcard").height();

        this.interval = setInterval(() => {
            this.timer += 20
            if (this.timer > this.touchduration) {
                $(".bankcard").height(taille++);
            }
        }, 20)
    })
    $(".bankcard-calibrate-buttons .plus").on("touchend", function () {
        clearInterval(this.interval);
    })
    // BAGUIER - CALIBRER
    $(".coin-calibrated").on("click", function () {
        let content = $('.baguier__content');
        let coinSize = $(".coin").width();
        let url = $(".close-baguier").data("url");
        $.ajax(
            {
                cache: false,
                async: true,
                type: "GET",
                url: '/Product/ShowBaguierSize/',
                data: {
                    pixelSize: coinSize,
                    modele: "1Euro",
                    url : url,
                    size:52
                },
                success: function (data) {
                    content.html(data);
                },
                beforeSend: function () {
                    $('#preloader').show()
                },
                complete: function () {
                    ResizeRing(coinSize, "1Euro");
                    $('#preloader').hide();
                }
            });
    })
    $(".bankcard-calibrated").on("click", function () {
        let content = $('.baguier__content');
        let bankcardSize = $(".bankcard").height();
        let url = $(".close-baguier").data("url");

        $.ajax(
            {
                cache: false,
                async: true,
                type: "GET",
                url: '/Product/ShowBaguierSize/',
                data: {
                    pixelSize: bankcardSize,
                    modele: "CB",
                    url: url,
                    size:52
                },
                success: function (data) {
                    content.html(data);
                },
                beforeSend: function () {
                    $('#preloader').show()
                },
                complete: function () {
                    ResizeRing(bankcardSize, "CB");
                    $('#preloader').hide();
                }
            });
    })
    // BAGUIER - CHOIX TAILLE BAGUE
    $(".ring-calibrate-buttons .minus").on("click", function () {
        let ringSize = $(".ring-size").data("size");

        if (ringSize > 40 && ringSize <= 80) {
            let modele = $(".ring-calibrate-buttons").data("basemodele");
            $(".ring-size").data("size", ringSize - 1);
            $(".ring-size").html(ringSize - 1);
            ResizeRing($(".ring-calibrate-buttons").data("basesize"), modele);
        }
    })
    $(".ring-calibrate-buttons .minus").on("touchstart", function () {
        let ringSize = $(".ring-size").data("size");
        this.touchduration = 500;
        this.timer = 0;
        let modele = $(".ring-calibrate-buttons").data("basemodele");

        this.interval = setInterval(() => {
            this.timer += 100
            if (this.timer > this.touchduration) {
                if (ringSize > 40 && ringSize <= 80) {
                    ringSize--
                    $(".ring-size").data("size", ringSize);
                    $(".ring-size").html(ringSize);
                    ResizeRing($(".ring-calibrate-buttons").data("basesize"), modele);
                }
            }
        }, 100)
    })
    $(".ring-calibrate-buttons .minus").on("touchend", function () {
        clearInterval(this.interval);
    })
    $(".ring-calibrate-buttons .plus").on("click", function () {
        let ringSize = $(".ring-size").data("size");

        if (ringSize >= 40 && ringSize < 80) {
            let modele = $(".ring-calibrate-buttons").data("basemodele");
            $(".ring-size").data("size", ringSize + 1);
            $(".ring-size").html(ringSize + 1);
            ResizeRing($(".ring-calibrate-buttons").data("basesize"), modele);
        }
    })
    $(".ring-calibrate-buttons .plus").on("touchstart", function () {
        let ringSize = $(".ring-size").data("size");
        this.touchduration = 500;
        this.timer = 0;
        let modele = $(".ring-calibrate-buttons").data("basemodele");

        this.interval = setInterval(() => {
            this.timer += 100
            if (this.timer > this.touchduration) {
                if (ringSize >= 40 && ringSize < 80) {
                    ringSize++
                    $(".ring-size").data("size", ringSize);
                    $(".ring-size").html(ringSize);
                    ResizeRing($(".ring-calibrate-buttons").data("basesize"), modele);

                }
            }
        }, 100)
    })
    $(".ring-calibrate-buttons .plus").on("touchend", function () {
        clearInterval(this.interval);
    })

    // BAGUIER - TUTO
    $(".ring-tutorial").on("click", function () {
        let content = $('.baguier__content');
        let coinSize = $(".content__actions").data("basesize");
        let modele = $(".content__actions").data("basemodele");
        let ringSize = $(".ring-size").data("size");
        let url = $(".close-baguier").data("url");
        $.ajax(
            {
                cache: false,
                async: true,
                type: "GET",
                url: '/Product/ShowBaguierTutorial/',
                data: {
                    pixelSize: coinSize,
                    modele: modele,
                    url : url,
                    size : ringSize
                },
                success: function (data) {
                    content.html(data);
                },
                beforeSend: function () {
                    $('#preloader').show()
                },
                complete: function () {
                    $('#preloader').hide();
                }
            });
    })

    $(".content__return.-baguier").on("click", function () {
        let content = $('.baguier__content');
        let coinSize = $(".content__return.-baguier").data("size");
        let modele = $(".content__return.-baguier").data("modele");
        let ringSize = $(".content__return.-baguier").data("ringsize");
        let url = $(".close-baguier").data("url");

        $.ajax(
            {
                cache: false,
                async: true,
                type: "GET",
                url: '/Product/ShowBaguierSize/',
                data: {
                    pixelSize: coinSize,
                    modele: modele,
                    url: url,
                    size : ringSize
                },
                success: function (data) {
                    content.html(data);
                },
                beforeSend: function () {
                    $('#preloader').show()
                },
                complete: function () {
                    ResizeRing(coinSize, modele);
                    $('#preloader').hide();
                }
            });
    })
    $(".content__return.-main").on("click", function () {
        let content = $('.baguier-modal');
        $.ajax({
            cache: false,
            async: true,
            type: "GET",
            url: '/Product/Baguier/',
            success: function (data) {
                $(".close-baguier").remove();
                content.replaceWith(data);
            },

        });
    })

    $(".close-baguier").on("click", function () {
        $('#preloader').show()
        window.location = $(".close-baguier").data("url");
    })
    
}